/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Billing_Contract_OverageInputs */



/**
* | output |
* | --- |
* | "Pay-per-use beyond the budget: {amount} — not invoiced, charge it separately." |
*
* @param {Partner_Billing_Contract_OverageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_contract_overage = /** @type {((inputs: Partner_Billing_Contract_OverageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Contract_OverageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nutzungsbasiert über das Budget hinaus: ${i?.amount} — nicht berechnet, bitte separat abrechnen.`)
	return /** @type {LocalizedString} */ (`Pay-per-use beyond the budget: ${i?.amount} — not invoiced, charge it separately.`)
});